<template>
	<div>
		<modalconfirm ref="modalConvertProduct" @action="confirmConvert"/>
		<div class="text-h5">Konversi Produk Warehouse</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-row>
					<v-col cols="4">
						<v-autocomplete clearable id="product_from" item-text="product_name" item-value="product_id" outlined dense v-model="product_id_from" :items="listProductFrom" label="Produk Asal" no-data-text="Tidak ada data yang sesuai" @focus="() => konfirmResponse.product_id_from = ''" :error-messages="konfirmResponse.product_id_from"></v-autocomplete>
					</v-col>
					<v-col cols="4">
						<v-autocomplete clearable id="product_to" item-text="product_name" item-value="product_id" outlined dense v-model="product_id_to" :items="listProductTo" label="Produk Tujuan" no-data-text="Tidak ada data yang sesuai" @focus="() => konfirmResponse.product_id_to = ''" :error-messages="konfirmResponse.product_id_to"></v-autocomplete>
					</v-col>
					<v-col cols="4">
						<v-currency-field v-model="quantity" label="Jumlah" outlined dense hide-details="auto" background-color="white" @focus="() => konfirmResponse.quantity = ''" :error-messages="konfirmResponse.quantity"></v-currency-field>
						<!-- <v-text-field outlined dense @focus="() => konfirmResponse.quantity = ''" :error-messages="konfirmResponse.quantity" v-model="quantity" label="Jumlah"></v-text-field> -->
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" depressed class="text-capitalize" @click="convert">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	data() {
		return {
			quantity: '',
			product_id_from: '',
			product_id_to: '',
		}
	},
	computed: {
		...mapState('productList', ['productConvert', 'konfirmResponse']),

		listProductFrom() {
			return this.productConvert.filter(el => el.product_id != this.product_id_to)
		},
		listProductTo() {
			return this.productConvert.filter(el => el.product_id != this.product_id_from)
		}
	},
	methods: {
		...mapActions('productList', ['getProductConvert', 'convertProduct']),
		...mapMutations('productList', ['clearDataProduct']),
		...mapMutations(['setOverlay']),

		convert() {
			let product_from = this.productConvert.find(el => el.product_id == this.product_id_from)
			let product_to = this.productConvert.find(el => el.product_id == this.product_id_to)
			let msg = `Yakin ingin konversi stok ${product_from.product_name} ke ${product_to.product_name} sejumlah ${this.quantity}?`
			this.$refs.modalConvertProduct.showConfirm()
			this.$refs.modalConvertProduct.setMessage(msg)
		},
		async confirmConvert() {
			await this.setOverlay(true)
			await this.$refs.modalConvertProduct.hideConfirm()
			let params = await {
				product_id_from: this.product_id_from,
				product_id_to: this.product_id_to,
				quantity: this.quantity
			}
			await this.convertProduct(params).then( () => {
				this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.quantity = ''
			this.product_id_from = ''
			this.product_id_to = ''
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Konversi Stok Produk`)
		this.getProductConvert(this.queryString({limit:100}))
	},
	beforeDestroy() {
		this.clearDataProduct()
	},
}
</script>